import { render, staticRenderFns } from "./TipoContas.vue?vue&type=template&id=05a0a504&"
import script from "./tipoConta.js?vue&type=script&lang=js&"
export * from "./tipoConta.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports